'use strict';

var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/ui/index.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import debounce from 'lodash/debounce';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { HotKeys } from 'react-hotkeys';
import { defineMessages, useIntl } from 'react-intl';
import { Switch, useHistory, useLocation, Redirect } from 'react-router-dom';
import { fetchFollowRequests } from 'soapbox/actions/accounts';
import { fetchReports, fetchUsers, fetchConfig } from 'soapbox/actions/admin';
import { fetchAnnouncements } from 'soapbox/actions/announcements';
import { fetchChats } from 'soapbox/actions/chats';
import { uploadCompose, resetCompose } from 'soapbox/actions/compose';
import { fetchCustomEmojis } from 'soapbox/actions/custom-emojis';
import { fetchFilters } from 'soapbox/actions/filters';
import { fetchMarker } from 'soapbox/actions/markers';
import { openModal } from 'soapbox/actions/modals';
import { expandNotifications } from 'soapbox/actions/notifications';
import { register as registerPushNotifications } from 'soapbox/actions/push-notifications';
import { fetchScheduledStatuses } from 'soapbox/actions/scheduled-statuses';
import { connectUserStream } from 'soapbox/actions/streaming';
import { fetchSuggestionsForTimeline } from 'soapbox/actions/suggestions';
import { expandHomeTimeline } from 'soapbox/actions/timelines';
import Icon from 'soapbox/components/icon';
import SidebarNavigation from 'soapbox/components/sidebar-navigation';
import ThumbNavigation from 'soapbox/components/thumb-navigation';
import { Layout } from 'soapbox/components/ui';
import { useAppDispatch, useAppSelector, useOwnAccount, useSoapboxConfig, useFeatures } from 'soapbox/hooks';
import AdminPage from 'soapbox/pages/admin-page';
import DefaultPage from 'soapbox/pages/default-page'; // import GroupsPage from 'soapbox/pages/groups_page';
// import GroupPage from 'soapbox/pages/group_page';

import HomePage from 'soapbox/pages/home-page';
import ProfilePage from 'soapbox/pages/profile-page';
import RemoteInstancePage from 'soapbox/pages/remote-instance-page';
import StatusPage from 'soapbox/pages/status-page';
import { getAccessToken, getVapidKey } from 'soapbox/utils/auth';
import { isStandalone } from 'soapbox/utils/state'; // import GroupSidebarPanel from '../groups/sidebar_panel';

import BackgroundShapes from './components/background-shapes';
import Navbar from './components/navbar';
import BundleContainer from './containers/bundle-container';
import { Status, CommunityTimeline, PublicTimeline, RemoteTimeline, AccountTimeline, AccountGallery, HomeTimeline, Followers, Following, DirectTimeline, Conversations, HashtagTimeline, Notifications, FollowRequests, GenericNotFound, FavouritedStatuses, Blocks, DomainBlocks, Mutes, Filters, PinnedStatuses, Search, // Groups,
// GroupTimeline,
ListTimeline, Lists, Bookmarks, // GroupMembers,
// GroupRemovedAccounts,
// GroupCreate,
// GroupEdit,
Settings, MediaDisplay, EditProfile, EditEmail, EditPassword, EmailConfirmation, DeleteAccount, SoapboxConfig, // ExportData,
ImportData, // Backups,
MfaForm, ChatIndex, ChatRoom, ChatPanes, ServerInfo, Dashboard, ModerationLog, CryptoDonate, ScheduledStatuses, UserIndex, FederationRestrictions, Aliases, Migration, FollowRecommendations, Directory, SidebarMenu, UploadArea, ProfileHoverCard, StatusHoverCard, Share, NewStatus, IntentionalError, Developers, CreateApp, SettingsStore, TestTimeline, LogoutPage, AuthTokenList, ServiceWorkerInfo } from './util/async-components';
import { WrappedRoute } from './util/react-router-helpers'; // Dummy import, to make sure that <Status /> ends up in the application bundle.
// Without this it ends up in ~8 very commonly used bundles.

import 'soapbox/components/status';
const EmptyPage = HomePage;

const isMobile = width => width <= 1190;

const messages = defineMessages({
  beforeUnload: {
    "id": "ui.beforeunload",
    "defaultMessage": "Your draft will be lost if you leave."
  },
  publish: {
    "id": "compose_form.publish",
    "defaultMessage": "Publish"
  }
});
const keyMap = {
  help: '?',
  new: 'n',
  search: 's',
  forceNew: 'option+n',
  reply: 'r',
  favourite: 'f',
  react: 'e',
  boost: 'b',
  mention: 'm',
  open: ['enter', 'o'],
  openProfile: 'p',
  moveDown: ['down', 'j'],
  moveUp: ['up', 'k'],
  back: 'backspace',
  goToHome: 'g h',
  goToNotifications: 'g n',
  goToFavourites: 'g f',
  goToPinned: 'g p',
  goToProfile: 'g u',
  goToBlocked: 'g b',
  goToMuted: 'g m',
  goToRequests: 'g r',
  toggleHidden: 'x',
  toggleSensitive: 'h',
  openMedia: 'a'
};

const SwitchingColumnsArea = _ref => {
  let {
    children
  } = _ref;
  const features = useFeatures();
  const {
    search
  } = useLocation();
  const {
    authenticatedProfile,
    cryptoAddresses
  } = useSoapboxConfig();
  const hasCrypto = cryptoAddresses.size > 0; // NOTE: Mastodon and Pleroma route some basenames to the backend.
  // When adding new routes, use a basename that does NOT conflict
  // with a known backend route, but DO redirect the backend route
  // to the corresponding component as a fallback.
  // Ex: use /login instead of /auth, but redirect /auth to /login

  return /*#__PURE__*/React.createElement(Switch, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 173,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/email-confirmation",
    page: EmptyPage,
    component: EmailConfirmation,
    publicRoute: true,
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 174,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/logout",
    page: EmptyPage,
    component: LogoutPage,
    publicRoute: true,
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 175,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/",
    exact: true,
    page: HomePage,
    component: HomeTimeline,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 177,
      columnNumber: 7
    }
  }), features.federating && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/timeline/local",
    exact: true,
    page: HomePage,
    component: CommunityTimeline,
    content: children,
    publicRoute: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 183,
      columnNumber: 31
    }
  }), features.federating && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/timeline/fediverse",
    exact: true,
    page: HomePage,
    component: PublicTimeline,
    content: children,
    publicRoute: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 184,
      columnNumber: 31
    }
  }), features.federating && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/timeline/:instance",
    exact: true,
    page: RemoteInstancePage,
    component: RemoteTimeline,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 185,
      columnNumber: 31
    }
  }), features.conversations && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/conversations",
    page: DefaultPage,
    component: Conversations,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 187,
      columnNumber: 34
    }
  }), features.directTimeline && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/messages",
    page: DefaultPage,
    component: DirectTimeline,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 188,
      columnNumber: 35
    }
  }), features.conversations && !features.directTimeline && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/messages",
    page: DefaultPage,
    component: Conversations,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 190,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/web/:path1/:path2/:path3",
    to: "/:path1/:path2/:path3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 206,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/web/:path1/:path2",
    to: "/:path1/:path2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 207,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/web/:path",
    to: "/:path",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 208,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/timelines/home",
    to: "/",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 209,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/timelines/public/local",
    to: "/timeline/local",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 210,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/timelines/public",
    to: "/timeline/fediverse",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 211,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/timelines/direct",
    to: "/messages",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 212,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/main/all",
    to: "/timeline/fediverse",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 215,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/main/public",
    to: "/timeline/local",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 216,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/main/friends",
    to: "/",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 217,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/tag/:id",
    to: "/tags/:id",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 218,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/user-settings",
    to: "/settings/profile",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 219,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/notice/:statusId",
    publicRoute: true,
    exact: true,
    page: DefaultPage,
    component: Status,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 220,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/users/:username/statuses/:statusId",
    to: "/@:username/posts/:statusId",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 221,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/users/:username/chats",
    to: "/chats",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 222,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/users/:username",
    to: "/@:username",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 223,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/registration",
    to: "/",
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 224,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/home",
    to: "/",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 227,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/admin",
    to: "/soapbox/admin",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 230,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/terms",
    to: "/about",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 231,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/settings/preferences",
    to: "/settings",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 232,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/settings/two_factor_authentication_methods",
    to: "/settings/mfa",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 233,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/settings/otp_authentication",
    to: "/settings/mfa",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 234,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/settings/applications",
    to: "/developers",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 235,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/auth/edit",
    to: "/settings",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 236,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/auth/confirmation",
    to: "/email-confirmation".concat(search),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 237,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/auth/reset_password",
    to: "/reset-password",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 238,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/auth/edit_password",
    to: "/edit-password",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 239,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/auth/sign_in",
    to: "/login",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 240,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/auth/sign_out",
    to: "/logout",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 241,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/registration/:token",
    to: "/invite/:token",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 244,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/canary",
    to: "/about/canary",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 247,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/canary.txt",
    to: "/about/canary",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 248,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/auth/external",
    to: "/login/external",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 249,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/auth/mfa",
    to: "/settings/mfa",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 250,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/auth/password/new",
    to: "/reset-password",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 251,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/auth/password/edit",
    to: "/edit-password".concat(search),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 252,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/tags/:id",
    publicRoute: true,
    page: DefaultPage,
    component: HashtagTimeline,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 254,
      columnNumber: 7
    }
  }), features.lists && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/lists",
    page: DefaultPage,
    component: Lists,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 256,
      columnNumber: 26
    }
  }), features.lists && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/list/:id",
    page: HomePage,
    component: ListTimeline,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 257,
      columnNumber: 26
    }
  }), features.bookmarks && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/bookmarks",
    page: DefaultPage,
    component: Bookmarks,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 258,
      columnNumber: 30
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/notifications",
    page: DefaultPage,
    component: Notifications,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 260,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/search",
    page: DefaultPage,
    component: Search,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 262,
      columnNumber: 7
    }
  }), features.suggestions && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/suggestions",
    publicRoute: true,
    page: DefaultPage,
    component: FollowRecommendations,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 263,
      columnNumber: 32
    }
  }), features.profileDirectory && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/directory",
    publicRoute: true,
    page: DefaultPage,
    component: Directory,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 264,
      columnNumber: 37
    }
  }), features.chats && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/chats",
    exact: true,
    page: DefaultPage,
    component: ChatIndex,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 266,
      columnNumber: 26
    }
  }), features.chats && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/chats/:chatId",
    page: DefaultPage,
    component: ChatRoom,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 267,
      columnNumber: 26
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/follow_requests",
    page: DefaultPage,
    component: FollowRequests,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 269,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/blocks",
    page: DefaultPage,
    component: Blocks,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 270,
      columnNumber: 7
    }
  }), features.federating && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/domain_blocks",
    page: DefaultPage,
    component: DomainBlocks,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 271,
      columnNumber: 31
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/mutes",
    page: DefaultPage,
    component: Mutes,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 272,
      columnNumber: 7
    }
  }), features.filters && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/filters",
    page: DefaultPage,
    component: Filters,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 273,
      columnNumber: 28
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/@:username",
    publicRoute: true,
    exact: true,
    component: AccountTimeline,
    page: ProfilePage,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 274,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/@:username/with_replies",
    publicRoute: !authenticatedProfile,
    component: AccountTimeline,
    page: ProfilePage,
    content: children,
    componentParams: {
      withReplies: true
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 275,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/@:username/followers",
    publicRoute: !authenticatedProfile,
    component: Followers,
    page: ProfilePage,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 276,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/@:username/following",
    publicRoute: !authenticatedProfile,
    component: Following,
    page: ProfilePage,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 277,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/@:username/media",
    publicRoute: !authenticatedProfile,
    component: AccountGallery,
    page: ProfilePage,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 278,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/@:username/tagged/:tag",
    exact: true,
    component: AccountTimeline,
    page: ProfilePage,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 279,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/@:username/favorites",
    component: FavouritedStatuses,
    page: ProfilePage,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 280,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/@:username/pins",
    component: PinnedStatuses,
    page: ProfilePage,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 281,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/@:username/posts/:statusId",
    publicRoute: true,
    exact: true,
    page: StatusPage,
    component: Status,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 282,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/@:username/:statusId",
    to: "/@:username/posts/:statusId",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 283,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/statuses/new",
    page: DefaultPage,
    component: NewStatus,
    content: children,
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 285,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/statuses/:statusId",
    exact: true,
    page: StatusPage,
    component: Status,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 286,
      columnNumber: 7
    }
  }), features.scheduledStatuses && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/scheduled_statuses",
    page: DefaultPage,
    component: ScheduledStatuses,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 287,
      columnNumber: 38
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/settings/profile",
    page: DefaultPage,
    component: EditProfile,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 289,
      columnNumber: 7
    }
  }), features.importData && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/settings/import",
    page: DefaultPage,
    component: ImportData,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 292,
      columnNumber: 31
    }
  }), features.accountAliases && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/settings/aliases",
    page: DefaultPage,
    component: Aliases,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 293,
      columnNumber: 35
    }
  }), features.accountMoving && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/settings/migration",
    page: DefaultPage,
    component: Migration,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 294,
      columnNumber: 34
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/settings/email",
    page: DefaultPage,
    component: EditEmail,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 295,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/settings/password",
    page: DefaultPage,
    component: EditPassword,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 296,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/settings/account",
    page: DefaultPage,
    component: DeleteAccount,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 297,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/settings/media_display",
    page: DefaultPage,
    component: MediaDisplay,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 298,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/settings/mfa",
    page: DefaultPage,
    component: MfaForm,
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 299,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/settings/tokens",
    page: DefaultPage,
    component: AuthTokenList,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 300,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/settings",
    page: DefaultPage,
    component: Settings,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 301,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/soapbox/config",
    adminOnly: true,
    page: DefaultPage,
    component: SoapboxConfig,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 303,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/soapbox/admin",
    staffOnly: true,
    page: AdminPage,
    component: Dashboard,
    content: children,
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 305,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/soapbox/admin/approval",
    staffOnly: true,
    page: AdminPage,
    component: Dashboard,
    content: children,
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 306,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/soapbox/admin/reports",
    staffOnly: true,
    page: AdminPage,
    component: Dashboard,
    content: children,
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 307,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/soapbox/admin/log",
    staffOnly: true,
    page: AdminPage,
    component: ModerationLog,
    content: children,
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 308,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/soapbox/admin/users",
    staffOnly: true,
    page: AdminPage,
    component: UserIndex,
    content: children,
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 309,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/info",
    page: EmptyPage,
    component: ServerInfo,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 310,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/developers/apps/create",
    developerOnly: true,
    page: DefaultPage,
    component: CreateApp,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 312,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/developers/settings_store",
    developerOnly: true,
    page: DefaultPage,
    component: SettingsStore,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 313,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/developers/timeline",
    developerOnly: true,
    page: DefaultPage,
    component: TestTimeline,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 314,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/developers/sw",
    developerOnly: true,
    page: DefaultPage,
    component: ServiceWorkerInfo,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 315,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/developers",
    page: DefaultPage,
    component: Developers,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 316,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/error/network",
    developerOnly: true,
    page: EmptyPage,
    component: () => new Promise((_resolve, reject) => reject()),
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 317,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/error",
    developerOnly: true,
    page: EmptyPage,
    component: IntentionalError,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 318,
      columnNumber: 7
    }
  }), hasCrypto && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/donate/crypto",
    publicRoute: true,
    page: DefaultPage,
    component: CryptoDonate,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 320,
      columnNumber: 21
    }
  }), features.federating && /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/federation_restrictions",
    publicRoute: true,
    page: DefaultPage,
    component: FederationRestrictions,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 321,
      columnNumber: 31
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    path: "/share",
    page: DefaultPage,
    component: Share,
    content: children,
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 323,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(WrappedRoute, {
    page: EmptyPage,
    component: GenericNotFound,
    content: children,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 325,
      columnNumber: 7
    }
  }));
};

const UI = _ref2 => {
  let {
    children
  } = _ref2;
  const intl = useIntl();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [draggingOver, setDraggingOver] = useState(false);
  const [mobile, setMobile] = useState(isMobile(window.innerWidth));
  const dragTargets = useRef([]);
  const disconnect = useRef(null);
  const node = useRef(null);
  const hotkeys = useRef(null);
  const me = useAppSelector(state => state.me);
  const account = useOwnAccount();
  const features = useFeatures();
  const vapidKey = useAppSelector(state => getVapidKey(state));
  const dropdownMenuIsOpen = useAppSelector(state => state.dropdown_menu.openId !== null);
  const accessToken = useAppSelector(state => getAccessToken(state));
  const streamingUrl = useAppSelector(state => state.instance.urls.get('streaming_api'));
  const standalone = useAppSelector(isStandalone);

  const handleDragEnter = e => {
    e.preventDefault();

    if (e.target && !dragTargets.current.includes(e.target)) {
      dragTargets.current.push(e.target);
    }

    if (e.dataTransfer && Array.from(e.dataTransfer.types).includes('Files')) {
      setDraggingOver(true);
    }
  };

  const handleDragOver = e => {
    if (dataTransferIsText(e.dataTransfer)) return false;
    e.preventDefault();
    e.stopPropagation();

    try {
      if (e.dataTransfer) {
        e.dataTransfer.dropEffect = 'copy';
      }
    } catch (err) {// Do nothing
    }

    return false;
  };

  const handleDrop = e => {
    if (!me) return;
    if (dataTransferIsText(e.dataTransfer)) return;
    e.preventDefault();
    setDraggingOver(false);
    dragTargets.current = [];
    dispatch((_, getState) => {
      if (e.dataTransfer && e.dataTransfer.files.length >= 1) {
        var _modals$last;

        const modals = getState().modals;
        const isModalOpen = ((_modals$last = modals.last()) === null || _modals$last === void 0 ? void 0 : _modals$last.modalType) === 'COMPOSE';
        dispatch(uploadCompose(isModalOpen ? 'compose-modal' : 'home', e.dataTransfer.files, intl));
      }
    });
  };

  const handleDragLeave = e => {
    e.preventDefault();
    e.stopPropagation();
    dragTargets.current = dragTargets.current.filter(el => {
      var _node$current;

      return el !== e.target && ((_node$current = node.current) === null || _node$current === void 0 ? void 0 : _node$current.contains(el));
    });

    if (dragTargets.current.length > 0) {
      return;
    }

    setDraggingOver(false);
  };

  const dataTransferIsText = dataTransfer => {
    return dataTransfer && Array.from(dataTransfer.types).includes('text/plain') && dataTransfer.items.length === 1;
  };

  const closeUploadModal = () => {
    setDraggingOver(false);
  };

  const handleServiceWorkerPostMessage = _ref3 => {
    let {
      data
    } = _ref3;

    if (data.type === 'navigate') {
      history.push(data.path);
    } else {
      console.warn('Unknown message type:', data.type);
    }
  };

  const connectStreaming = () => {
    if (!disconnect.current && accessToken && streamingUrl) {
      disconnect.current = dispatch(connectUserStream());
    }
  };

  const disconnectStreaming = () => {
    if (disconnect.current) {
      disconnect.current();
      disconnect.current = null;
    }
  };

  const handleResize = useCallback(debounce(() => {
    setMobile(isMobile(window.innerWidth));
  }, 500, {
    trailing: true
  }), [setMobile]);
  /** Load initial data when a user is logged in */

  const loadAccountData = () => {
    if (!account) return;
    dispatch(expandHomeTimeline({}, () => {
      dispatch(fetchSuggestionsForTimeline());
    }));
    dispatch(expandNotifications()) // @ts-ignore
    .then(() => dispatch(fetchMarker(['notifications']))).catch(console.error);
    dispatch(fetchAnnouncements());

    if (features.chats) {
      dispatch(fetchChats());
    }

    if (account.staff) {
      dispatch(fetchReports({
        resolved: false
      }));
      dispatch(fetchUsers(['local', 'need_approval']));
    }

    if (account.admin) {
      dispatch(fetchConfig());
    }

    setTimeout(() => dispatch(fetchFilters()), 500);

    if (account.locked) {
      setTimeout(() => dispatch(fetchFollowRequests()), 700);
    }

    setTimeout(() => dispatch(fetchScheduledStatuses()), 900);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize, {
      passive: true
    });
    document.addEventListener('dragenter', handleDragEnter, false);
    document.addEventListener('dragover', handleDragOver, false);
    document.addEventListener('drop', handleDrop, false);
    document.addEventListener('dragleave', handleDragLeave, false);

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', handleServiceWorkerPostMessage);
    }

    if (typeof window.Notification !== 'undefined' && Notification.permission === 'default') {
      window.setTimeout(() => Notification.requestPermission(), 120 * 1000);
    }

    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('dragenter', handleDragEnter);
      document.removeEventListener('dragover', handleDragOver);
      document.removeEventListener('drop', handleDrop);
      document.removeEventListener('dragleave', handleDragLeave);
      disconnectStreaming();
    };
  }, []);
  useEffect(() => {
    connectStreaming();
  }, [accessToken, streamingUrl]); // The user has logged in

  useEffect(() => {
    loadAccountData();
    dispatch(fetchCustomEmojis());
  }, [!!account]);
  useEffect(() => {
    dispatch(registerPushNotifications());
  }, [vapidKey]);

  const handleHotkeyNew = e => {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    if (!node.current) return;
    const element = node.current.querySelector('textarea#compose-textarea');

    if (element) {
      element.focus();
    }
  };

  const handleHotkeySearch = e => {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    if (!node.current) return;
    const element = node.current.querySelector('input#search');

    if (element) {
      element.focus();
    }
  };

  const handleHotkeyForceNew = e => {
    handleHotkeyNew(e);
    dispatch(resetCompose());
  };

  const handleHotkeyBack = () => {
    if (window.history && window.history.length === 1) {
      history.push('/');
    } else {
      history.goBack();
    }
  };

  const setHotkeysRef = c => {
    hotkeys.current = c;
    if (!me || !hotkeys.current) return; // @ts-ignore

    hotkeys.current.__mousetrap__.stopCallback = (_e, element) => {
      return ['TEXTAREA', 'SELECT', 'INPUT'].includes(element.tagName);
    };
  };

  const handleHotkeyToggleHelp = () => {
    dispatch(openModal('HOTKEYS'));
  };

  const handleHotkeyGoToHome = () => {
    history.push('/');
  };

  const handleHotkeyGoToNotifications = () => {
    history.push('/notifications');
  };

  const handleHotkeyGoToFavourites = () => {
    if (!account) return;
    history.push("/@".concat(account.username, "/favorites"));
  };

  const handleHotkeyGoToPinned = () => {
    if (!account) return;
    history.push("/@".concat(account.username, "/pins"));
  };

  const handleHotkeyGoToProfile = () => {
    if (!account) return;
    history.push("/@".concat(account.username));
  };

  const handleHotkeyGoToBlocked = () => {
    history.push('/blocks');
  };

  const handleHotkeyGoToMuted = () => {
    history.push('/mutes');
  };

  const handleHotkeyGoToRequests = () => {
    history.push('/follow_requests');
  };

  const handleOpenComposeModal = () => {
    dispatch(openModal('COMPOSE'));
  };

  const shouldHideFAB = () => {
    const path = location.pathname;
    return Boolean(path.match(/^\/posts\/|^\/search|^\/getting-started|^\/chats/));
  }; // Wait for login to succeed or fail


  if (me === null) return null;
  const handlers = {
    help: handleHotkeyToggleHelp,
    new: handleHotkeyNew,
    search: handleHotkeySearch,
    forceNew: handleHotkeyForceNew,
    back: handleHotkeyBack,
    goToHome: handleHotkeyGoToHome,
    goToNotifications: handleHotkeyGoToNotifications,
    goToFavourites: handleHotkeyGoToFavourites,
    goToPinned: handleHotkeyGoToPinned,
    goToProfile: handleHotkeyGoToProfile,
    goToBlocked: handleHotkeyGoToBlocked,
    goToMuted: handleHotkeyGoToMuted,
    goToRequests: handleHotkeyGoToRequests
  };
  const fabElem = /*#__PURE__*/React.createElement("button", {
    key: "floating-action-button",
    onClick: handleOpenComposeModal,
    className: "floating-action-button",
    "aria-label": intl.formatMessage(messages.publish),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 639,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/pencil-plus.svg'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 645,
      columnNumber: 7
    }
  }));
  const floatingActionButton = shouldHideFAB() ? null : fabElem;
  const style = {
    pointerEvents: dropdownMenuIsOpen ? 'none' : undefined
  };
  return /*#__PURE__*/React.createElement(HotKeys, {
    keyMap: keyMap,
    handlers: me ? handlers : undefined,
    ref: setHotkeysRef,
    attach: window,
    focused: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 656,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: node,
    style: style,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 657,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(BackgroundShapes, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 658,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "z-10 flex flex-col",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 660,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Navbar, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 661,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(Layout, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 663,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Layout.Sidebar, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 664,
      columnNumber: 13
    }
  }, !standalone && /*#__PURE__*/React.createElement(SidebarNavigation, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 665,
      columnNumber: 31
    }
  })), /*#__PURE__*/React.createElement(SwitchingColumnsArea, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 668,
      columnNumber: 13
    }
  }, children)), me && floatingActionButton, /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: UploadArea,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 675,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    active: draggingOver,
    onClose: closeUploadModal,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 676,
      columnNumber: 27
    }
  })), me && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: SidebarMenu,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 680,
      columnNumber: 13
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 681,
      columnNumber: 29
    }
  })), me && features.chats && !mobile && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: ChatPanes,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 685,
      columnNumber: 13
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 686,
      columnNumber: 29
    }
  })), /*#__PURE__*/React.createElement(ThumbNavigation, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 689,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: ProfileHoverCard,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 691,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 692,
      columnNumber: 27
    }
  })), /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: StatusHoverCard,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 695,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 696,
      columnNumber: 27
    }
  })))));
};

export default UI;